import http from './../../../base/api/public'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre

export default {
    getPage(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getPage', params)
    },
    delete(params) {
        return http.requestPostKeyValue(apiPre + service.rbac + '/rbac/user/delete', params)
    },
    getDtoById(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getDto/' + params, {})
    },
    insert(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/insert', params)
    },
    update(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/update', params)
    },
    getUser(params) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/getByUser', params)
    },
    findByUsernameOrMobile(param) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/findByUsernameOrMobile/' + param, {})
    },
    updatePersonalInfo(param) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/updatePersonalInfo', param)
    },
    getDetail(id) {
        return http.requestPost(apiPre + service.rbac + '/rbac/user/detail/' + id, {})
    }
}


// WEBPACK FOOTER //
// ./src/module/systemManagement/api/user.js